import { IObject } from './defaultTypes';

export const treatSearch = (search: string) => {
  let maxLength;
  let type;

  if (Number(search)) {
    maxLength = 20;
    if (search.length >= 7 && search.length <= 13) {
      type = 'msisdn';
    } else if (search.length > 13 && search.length <= 15) {
      type = 'imsi';
    } else if (search.length > 19 && search.length <= 20) {
      type = 'iccid';
    } else {
      type = 'nickname';
    }
  } else {
    type = 'nickname';
  }

  return { maxLength, type };
};

export const treatSearchSettings = (settings: IObject | undefined) => {
  const searchHistory = settings?.callCenterSearchHistory;

  if (!searchHistory) {
    return [];
  }
  return typeof searchHistory === 'string' ? [searchHistory] : searchHistory;
};
